__turbopack_context__.v({
  "ganttChart": "cqpTcq_ganttChart",
  "ganttChart__cellButton": "cqpTcq_ganttChart__cellButton",
  "ganttChart__marker": "cqpTcq_ganttChart__marker",
  "ganttChart__markerLabel": "cqpTcq_ganttChart__markerLabel",
  "ganttChart__markers": "cqpTcq_ganttChart__markers",
  "ganttChart__surface": "cqpTcq_ganttChart__surface",
});
